<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
    name: 'App',
    mounted() {
        (function (win, doc) {
            if (!win.addEventListener) return;

            function setFont() {
                var html = document.documentElement;
                var k = 1920;
                // console.log(html.clientWidth)
                var clientwidh = html.clientWidth < 750 ? 750 : html.clientWidth > 1920 ? 1920 : html.clientWidth;
                html.style.fontSize = clientwidh / k * 100 + "px";
            }

            setFont();
            setTimeout(function () {
                setFont();
            }, 300);
            doc.addEventListener('DOMContentLoaded', setFont, false);
            win.addEventListener('resize', setFont, false);
            win.addEventListener('load', setFont, false);
        })(window, document);
    },
}
</script>

<style>
body, html {height: 100%;overflow: hidden;}
dl, dt, h1, h2, h3, h4, h5, h6, li, p, ul {margin: 0;padding: 0}
* {margin: 0;padding: 0;box-sizing: border-box;}
a {color: #5a5a5a;text-decoration: none}
li, ul {list-style: none}
img {vertical-align: middle}
.w1200 {width: 17rem;margin: 0 auto}

#app, .w1200 {position: relative}

#app {font-family: Microsoft YaHei, 微软雅黑;height: 100%;color: #5a5a5a;}
</style>



// WEBPACK FOOTER //
// src/App.vue